import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { SystemSelectService } from '../system-select/system-select.service';
import { TabStripModule } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-camtl-contacts',
  templateUrl: './camtl-contacts.component.html',
  styleUrls: ['./camtl-contacts.component.scss'],
  host: { 'style': 'width: 100%' },

})
export class CamtlContactsComponent implements OnInit {

  constructor(private router: Router, private systemSelectService: SystemSelectService) { }

  private currentRoute: any;
  private system: any;

  tabs = [
    {
      title: "Program Contacts",
      route: "ProgramContacts"
    },
    {
      title: "Zone Contacts",
      route: "ZoneContacts",
    },
    {
      title: "Source Contacts",
      route: "SourceContacts",
    },
    {
      title: "Project Contacts",
      route: "ProjectContacts",
    }
  ];

  ngOnInit() {
    this.systemSelectService.system$
      .subscribe(system => this.system = system);
    this.systemSelectService.get();

    this.router.events.subscribe((val) => {
      this.setSelectedTab();
    });

    this.setSelectedTab();
  }

  //handle tab change when changing URL via browser / refreshing the page
  setSelectedTab() {
    try {
      var componentUrl = this.router.url.split("/").pop();

      this.tabs.map(tab => tab["selected"] = false);
      this.tabs.some(tab => tab["selected"] = tab.route === componentUrl);
    } catch (e) {
      console.error(e.status, e.message);
    }
  }

  private selectedId: string = "";

  public handleSelect({ index }): boolean {
    this.router.navigate(["/MESC/CAMTL/Contacts/" + this.tabs[index].route]);
    return false;
  }

  isSelected(route): boolean {
    if (!this.currentRoute) return false;
    return '/' + route === this.currentRoute.url;
  }
}
